import ChatMessagesView from './ChatMessagesViewContainer';

export default ChatMessagesView;
